import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { ModuleArtifactCard } from "./ModuleArtifactCard";
import type { ModuleArtifact } from "./types";

type Props = {
	title?: string;
	artifacts: ModuleArtifact[];
	selectedArtifactId?: string;
	onArtifactPress: (artifact: ModuleArtifact) => void;
};

export const ModuleArtifactsSection = ({
	title,
	artifacts,
	selectedArtifactId,
	onArtifactPress,
}: Props) => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();
	const completedCount = artifacts.filter(
		(artifact) => artifact.status === "completed",
	).length;

	return (
		<Box gap={16} paddingTop={24} paddingBottom={24}>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				gap={12}
				paddingHorizontal={isMobile ? 16 : 0}
			>
				<Text variant="titleMedium">
					{title ?? t("lessons.detail.activities.title")}
				</Text>
				<Text variant="bodyMedium">
					{t("lessons.detail.activities.completedCount", {
						completed: completedCount,
						total: artifacts.length,
					})}
				</Text>
			</Box>
			<Box gap={8}>
				{artifacts.map((artifact) => (
					<ModuleArtifactCard
						key={artifact.id}
						artifact={artifact}
						selected={artifact.id === selectedArtifactId}
						onPress={onArtifactPress}
					/>
				))}
			</Box>
		</Box>
	);
};
